import { withWidth } from '@material-ui/core';
import { Button, Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const selectWindowInnerSize = (state) => state.windowInnerSize;

const useStyles = makeStyles({
  textMonarcha: {
    fontFamily: 'monarcha,open-sans !important',
    textTransform: 'uppercase !important',
    color: 'white ',
    fontWeight: 'bold !important',
  },
  textOpenSans: {
    fontFamily: 'open-sans,san-serif !important',
    whiteSpace: 'bold',
    textTransform: 'normal',
    color: 'white',
  },
});

const JoinTheWaitlistButton = ({ width, ...props }) => {
  let { variant, onClick, pageType } = props;
  if (width !== 'xl') {
    variant = 'small';
  }
  const windowInnerSize = useSelector(selectWindowInnerSize);
  const classes = useStyles();
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      if (pageType === 'agency') {
        // For agency page, just scroll to waitlist section
        const agencyElement = document.getElementById('AgencyPage');
        if (agencyElement) {
          agencyElement.scrollTo({
            top: agencyElement.scrollHeight - windowInnerSize.height * 2,
            behavior: 'smooth'
          });
        }
      } else {
        // For creator page or default, use /waitlist URL
        const creatorElement = document.getElementById('LandingPage1');
        if (creatorElement) {
          creatorElement.scrollTo({
            top: creatorElement.scrollHeight - windowInnerSize.height * 2,
            behavior: 'smooth'
          });
        }
        // navigate('/waitlist');
      }
    }
  };

  return (
    <Container>
      <Button
        className={classes.textOpenSans}
        sx={{
          textTransform: 'none',
          color: 'black',
          fontSize: variant === 'small' ? '16px' : '22px',
          lineHeight: 2.1,
          padding: variant === 'small' ? '5px 65px' : '10px 80px',
          background: '#ffbf12',
          borderRadius: '50px',
          margin: '0 auto',
          display: 'block',
          '&:hover': { background: '#ffbf12' },
        }}
        onClick={handleClick}
      >
        Join the Waitlist
      </Button>
    </Container>
  );
};

export default withWidth()(JoinTheWaitlistButton);
